import React, { forwardRef } from 'react';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import pickersTheme from './AmbPickersTheme';

const AmbDatePicker = forwardRef(
  (
    { required, error, disableFuture, disabled, format, id, label, margin, name, onAccept, onChange, openTo, value },
    ref,
  ) => {
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={pickersTheme}>
          <DesktopDatePicker
            name={name}
            margin={margin}
            value={value}
            disabled={disabled}
            onChange={onChange}
            onAccept={onAccept}
            label={label}
            format={format}
            openTo={openTo}
            disableFuture={disableFuture}
            id={id}
            inputRef={ref}
            slotProps={{ textField: { variant: 'standard', required, error } }}
          />
        </ThemeProvider>
      </StyledEngineProvider>
    );
  },
);

export default AmbDatePicker;
